<template>
  <span v-if="!params.data.isHost">
    <el-popconfirm
      :confirmButtonText="$t('yes')"
      :cancelButtonText="$t('no')"
      icon="el-icon-info"
      iconColor="red"
      :title="$t('areYouSure')"
      @confirm="deleteCompetitor"
    >
      <el-tooltip
        slot="reference"
        :content="$t('delete_competitor')"
        placement="top"
      >
        <i class="far fa-trash-alt"></i>
      </el-tooltip>
    </el-popconfirm>
  </span>
</template>

<script>
import { RepositoryFactory } from "@/services/repositoryFactory";

export default {
  data() {
    return {};
  },
  methods: {
    deleteCompetitor() {
      this.params.context.deleteCompetitor(this.params.data.id);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@use "styles/variables" as *;

.fa-trash-alt {
  cursor: pointer;
}
</style>

<i18n>
{
  "en": {
    "delete_competitor": "Delete competitor",
    "yes": "Yes",
    "no": "No",
    "areYouSure": "Are you sure ?"
  },
  "fr": {
    "delete_competitor": "Supprimer concurrent",
    "yes": "Oui",
    "no": "Non",
    "areYouSure": "Etes-vous sûr ?"
  },
  "de": {
    "delete_competitor": "Wettbewerber löschen",
    "yes": "Ja",
    "no": "Nicht",
    "areYouSure": "Bist du dir sicher ?"
  }
}
</i18n>
